import { ACTIVITY_TYPE } from "./enums";

export function normalizeQuickNoteDescription(description) {
  return (description || "").trim();
}

export function buildQuickNotePayload({ description, relationPayload }) {
  return {
    type: ACTIVITY_TYPE.NOTE,
    description: normalizeQuickNoteDescription(description),
    ...(relationPayload || {}),
  };
}

